import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=ef729018&scoped=true&"
import script from "./Transactions.vue?vue&type=script&lang=ts&"
export * from "./Transactions.vue?vue&type=script&lang=ts&"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=ef729018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef729018",
  null
  
)

export default component.exports